module.exports = __webpack_public_path__ + "static/media/warehouse_32_blue.0735a27e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/icons/warehouse_32_blue.svg
// module id = 1387
// module chunks = 0